import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GrDocumentCsv } from "react-icons/gr";
import "./LiveClassesPurchase.css";
import { MdDownload } from "react-icons/md";

const LiveClassesPurchase = () => {
  const navigate = useNavigate();
  const [liveClassesAll, setLiveClassesAll] = useState([]);
  const [liveClassesId, setLiveClassesId] = useState();
  const [liveClassName, setLiveClassName] = useState("");
  const [liveClassesPurchaseList, setLiveClassesPurchaseList] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  // console.log("--->", liveClassName);

  const handleExportFile = () => {
    axios
      .get(`${API_BASE_URL}/admin/live-classes/export-csv/${liveClassesId}`, {
        responseType: "blob", // Important for handling binary data
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Purchase_report.csv"; // Enclose filename in quotes
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        error.response?.data
          ? alert(error.response.data.msg)
          : alert(error.message);
      });
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/live-classes`)
      .then((response) => {
        // console.log(response.data?.data);
        const data = response.data?.data;
        setLiveClassesAll(data);
      })
      .catch((error) => console.log(error));
  }, [API_BASE_URL]);

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .get(`${API_BASE_URL}/admin/purchased-classes/${liveClassesId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        // console.log(response.data?.data);
        setLiveClassesPurchaseList(response.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader px-3">
        <div className="subjectHeaderdiv">
          <h5>Live Classes Purchase list</h5>
        </div>
        <div
          className="form-sub-container mt-4 d-flex justify-content-between align-items-center "
          id="form"
        >
          <form className="subject-detail-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Select Live Class</label>
              </div>
              <select
                className="select-dropdown"
                value={liveClassesId}
                onChange={(e) => {
                  setLiveClassesId(e.target.value);
                  setLiveClassName(e.target.title);
                }}
                required
              >
                <option value="">-Select Class</option>
                {liveClassesAll &&
                  liveClassesAll.map((liveClasses, idx) => (
                    <option
                      value={liveClasses._id}
                      title={liveClasses.title}
                      key={idx}
                    >
                      {liveClasses.title}
                    </option>
                  ))}
              </select>
              <div className="school-subj-form-btns">
                <button className="btn-search" type="submit">
                  Search
                </button>
              </div>
            </div>
          </form>
          <div className="fs-2 text-success " onClick={handleExportFile}>
            <GrDocumentCsv />
            <span className="fs-3 ms-1">
              <MdDownload />
            </span>
          </div>
        </div>

        <div className="classes-table-container">
          <h5>All Purchase List</h5>
          <table className="classes-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Student Name</th>
                <th>Mobile No.</th>
              </tr>
            </thead>
            <tbody>
              {liveClassesPurchaseList[0] ? (
                liveClassesPurchaseList.map((purchaseList, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{purchaseList.studentName}</td>
                    <td>{purchaseList.mobile}</td>
                  </tr>
                ))
              ) : (
                <tr className="fs-2 text-center">
                  <td colspan="3">No Data Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LiveClassesPurchase;
